module.exports = __webpack_public_path__ + "img/extension_skulist.ca86a7e2.png";